// src/team.ts
var ROLE_LABELS = {
  owner: "Propri\xE9taire",
  admin: "Administrateur",
  benevole: "B\xE9n\xE9vole",
  membre: "Membre"
};
var ROLE_COLORS = {
  owner: "warning",
  admin: "info",
  benevole: "success",
  membre: "neutral"
};
var ROLE_HIERARCHY = {
  owner: 0,
  admin: 1,
  benevole: 2,
  membre: 3
};
function canActOnRole(actorRole, targetRole) {
  return ROLE_HIERARCHY[actorRole] < ROLE_HIERARCHY[targetRole];
}
function isValidRole(role) {
  return ["owner", "admin", "benevole", "membre"].includes(role);
}
var PERMISSION_KEYS = [
  "canViewMembers",
  "canInviteMembers",
  "canRemoveMembers",
  "canUpdateRoles",
  "canEditOrganization",
  "canManageStripe",
  "canViewPayouts",
  "canDeleteOrganization",
  "canManageReferral",
  "canViewDonations",
  "canViewDonationAmounts",
  "canViewDonationCounts",
  "canExportDonations",
  "canRefundDonations",
  "canCancelSubscriptions",
  "canViewDonors",
  "canExportDonors",
  "canDeleteDonors",
  "canViewQRCodes",
  "canCreateQRCodes",
  "canEditQRCodes",
  "canDeleteQRCodes",
  "canViewQRCodeAmounts",
  "canViewQRCodeDonors",
  "canViewCampaigns",
  "canCreateCampaigns",
  "canEditCampaigns",
  "canDeleteCampaigns",
  "canViewCampaignAmounts",
  "canViewCampaignDonors",
  "canViewEvents",
  "canCreateEvents",
  "canEditEvents",
  "canDeleteEvents",
  "canCheckInTickets",
  "canViewEventAmounts",
  "canViewEventAttendees",
  "canViewMemberships",
  "canCreateMemberships",
  "canEditMemberships",
  "canDeleteMemberships",
  "canViewMembershipAmounts",
  "canViewMembershipMembers",
  "canViewShops",
  "canCreateShops",
  "canEditShops",
  "canDeleteShops",
  "canManageShopOrders",
  "canViewShopAmounts",
  "canViewShopCustomers",
  "canEditPublicPage",
  "canViewObjectives",
  "canCreateObjectives",
  "canEditObjectives",
  "canDeleteObjectives",
  "canUseTapToPay",
  "canViewDailyTotal",
  "canExportData",
  "canViewReports",
  "canEditPaymentLink"
];
var VALID_PERMISSION_KEYS = PERMISSION_KEYS;
var ROLE_PERMISSIONS = {
  owner: {
    // Équipe
    canViewMembers: true,
    canInviteMembers: true,
    canRemoveMembers: true,
    canUpdateRoles: true,
    // Organisation
    canEditOrganization: true,
    canManageStripe: true,
    canViewPayouts: true,
    canDeleteOrganization: true,
    canManageReferral: true,
    // Dons
    canViewDonations: true,
    canViewDonationAmounts: true,
    canViewDonationCounts: true,
    canExportDonations: true,
    canRefundDonations: true,
    canCancelSubscriptions: true,
    // Donateurs
    canViewDonors: true,
    canExportDonors: true,
    canDeleteDonors: true,
    // QR Codes
    canViewQRCodes: true,
    canCreateQRCodes: true,
    canEditQRCodes: true,
    canDeleteQRCodes: true,
    canViewQRCodeAmounts: true,
    canViewQRCodeDonors: true,
    // Cagnottes
    canViewCampaigns: true,
    canCreateCampaigns: true,
    canEditCampaigns: true,
    canDeleteCampaigns: true,
    canViewCampaignAmounts: true,
    canViewCampaignDonors: true,
    // Événements
    canViewEvents: true,
    canCreateEvents: true,
    canEditEvents: true,
    canDeleteEvents: true,
    canCheckInTickets: true,
    canViewEventAmounts: true,
    canViewEventAttendees: true,
    // Adhésions
    canViewMemberships: true,
    canCreateMemberships: true,
    canEditMemberships: true,
    canDeleteMemberships: true,
    canViewMembershipAmounts: true,
    canViewMembershipMembers: true,
    // === BOUTIQUE ===
    canViewShops: true,
    canCreateShops: true,
    canEditShops: true,
    canDeleteShops: true,
    canManageShopOrders: true,
    canViewShopAmounts: true,
    canViewShopCustomers: true,
    // Page publique
    canEditPublicPage: true,
    // Objectifs
    canViewObjectives: true,
    canCreateObjectives: true,
    canEditObjectives: true,
    canDeleteObjectives: true,
    // Tap To Pay
    canUseTapToPay: true,
    canViewDailyTotal: true,
    // Exports & Rapports
    canExportData: true,
    canViewReports: true,
    // Lien de paiement
    canEditPaymentLink: true
  },
  admin: {
    canViewMembers: true,
    canInviteMembers: true,
    canRemoveMembers: true,
    canUpdateRoles: true,
    canEditOrganization: true,
    canManageStripe: true,
    canViewPayouts: true,
    // owner only (irréversible)
    canDeleteOrganization: false,
    canManageReferral: true,
    canViewDonations: true,
    canViewDonationAmounts: true,
    canViewDonationCounts: true,
    canExportDonations: true,
    canRefundDonations: true,
    canCancelSubscriptions: true,
    canViewDonors: true,
    canExportDonors: true,
    canDeleteDonors: true,
    canViewQRCodes: true,
    canCreateQRCodes: true,
    canEditQRCodes: true,
    canDeleteQRCodes: true,
    canViewQRCodeAmounts: true,
    canViewQRCodeDonors: true,
    canViewCampaigns: true,
    canCreateCampaigns: true,
    canEditCampaigns: true,
    canDeleteCampaigns: true,
    canViewCampaignAmounts: true,
    canViewCampaignDonors: true,
    canViewEvents: true,
    canCreateEvents: true,
    canEditEvents: true,
    canDeleteEvents: true,
    canCheckInTickets: true,
    canViewEventAmounts: true,
    canViewEventAttendees: true,
    canViewMemberships: true,
    canCreateMemberships: true,
    canEditMemberships: true,
    canDeleteMemberships: true,
    canViewMembershipAmounts: true,
    canViewMembershipMembers: true,
    // === BOUTIQUE ===
    canViewShops: true,
    canCreateShops: true,
    canEditShops: true,
    canDeleteShops: true,
    canManageShopOrders: true,
    canViewShopAmounts: true,
    canViewShopCustomers: true,
    canEditPublicPage: true,
    canViewObjectives: true,
    canCreateObjectives: true,
    canEditObjectives: true,
    canDeleteObjectives: true,
    canUseTapToPay: true,
    canViewDailyTotal: true,
    canExportData: true,
    canViewReports: true,
    canEditPaymentLink: true
  },
  benevole: {
    canViewMembers: true,
    canInviteMembers: false,
    canRemoveMembers: false,
    canUpdateRoles: false,
    canEditOrganization: false,
    canManageStripe: false,
    canViewPayouts: false,
    canDeleteOrganization: false,
    canManageReferral: false,
    canViewDonations: true,
    // Peut voir les dons mais pas les montants
    canViewDonationAmounts: false,
    canViewDonationCounts: true,
    canExportDonations: false,
    canRefundDonations: false,
    canCancelSubscriptions: false,
    canViewDonors: true,
    canExportDonors: false,
    canDeleteDonors: false,
    canViewQRCodes: true,
    canCreateQRCodes: true,
    canEditQRCodes: false,
    canDeleteQRCodes: false,
    canViewQRCodeAmounts: false,
    canViewQRCodeDonors: true,
    canViewCampaigns: true,
    canCreateCampaigns: false,
    canEditCampaigns: false,
    canDeleteCampaigns: false,
    canViewCampaignAmounts: false,
    canViewCampaignDonors: true,
    canViewEvents: true,
    canCreateEvents: false,
    canEditEvents: false,
    canDeleteEvents: false,
    // Rôle naturel du bénévole : valider les billets à l'entrée
    canCheckInTickets: true,
    canViewEventAmounts: false,
    canViewEventAttendees: true,
    canViewMemberships: true,
    canCreateMemberships: false,
    canEditMemberships: false,
    canDeleteMemberships: false,
    canViewMembershipAmounts: false,
    canViewMembershipMembers: true,
    // === BOUTIQUE (parité billetterie : lecture seule) ===
    canViewShops: true,
    canCreateShops: false,
    canEditShops: false,
    canDeleteShops: false,
    canManageShopOrders: false,
    canViewShopAmounts: false,
    canViewShopCustomers: true,
    canEditPublicPage: false,
    canViewObjectives: true,
    canCreateObjectives: false,
    canEditObjectives: false,
    canDeleteObjectives: false,
    canUseTapToPay: true,
    canViewDailyTotal: false,
    canExportData: false,
    canViewReports: false,
    canEditPaymentLink: false
  },
  membre: {
    canViewMembers: true,
    canInviteMembers: false,
    canRemoveMembers: false,
    canUpdateRoles: false,
    canEditOrganization: false,
    canManageStripe: false,
    canViewPayouts: false,
    canDeleteOrganization: false,
    canManageReferral: false,
    canViewDonations: true,
    canViewDonationAmounts: false,
    canViewDonationCounts: false,
    canExportDonations: false,
    canRefundDonations: false,
    canCancelSubscriptions: false,
    canViewDonors: true,
    canExportDonors: false,
    canDeleteDonors: false,
    canViewQRCodes: true,
    canCreateQRCodes: false,
    canEditQRCodes: false,
    canDeleteQRCodes: false,
    canViewQRCodeAmounts: false,
    canViewQRCodeDonors: true,
    canViewCampaigns: true,
    canCreateCampaigns: false,
    canEditCampaigns: false,
    canDeleteCampaigns: false,
    canViewCampaignAmounts: false,
    canViewCampaignDonors: true,
    canViewEvents: true,
    canCreateEvents: false,
    canEditEvents: false,
    canDeleteEvents: false,
    canCheckInTickets: false,
    canViewEventAmounts: false,
    canViewEventAttendees: true,
    canViewMemberships: true,
    canCreateMemberships: false,
    canEditMemberships: false,
    canDeleteMemberships: false,
    canViewMembershipAmounts: false,
    canViewMembershipMembers: true,
    // === BOUTIQUE (parité billetterie : lecture seule) ===
    canViewShops: true,
    canCreateShops: false,
    canEditShops: false,
    canDeleteShops: false,
    canManageShopOrders: false,
    canViewShopAmounts: false,
    canViewShopCustomers: true,
    canEditPublicPage: false,
    canViewObjectives: true,
    canCreateObjectives: false,
    canEditObjectives: false,
    canDeleteObjectives: false,
    canUseTapToPay: false,
    canViewDailyTotal: false,
    canExportData: false,
    // 🔴 `false` depuis le 2026-09-14. Le rôle « membre » est le plus
    // restreint — il ne voit NI les montants des dons, NI leurs compteurs —
    // et pouvait pourtant ouvrir le rapport annuel et la synthèse comptable,
    // c'est-à-dire les mêmes montants agrégés. Le bénévole, lui, ne l'avait
    // pas : le rôle le plus bas en savait plus que celui du dessus.
    canViewReports: false,
    canEditPaymentLink: false
  }
};
function mergePermissions(rolePermissions, customPermissions) {
  if (!customPermissions) {
    return { ...rolePermissions };
  }
  const merged = { ...rolePermissions };
  for (const [key, value] of Object.entries(customPermissions)) {
    if (value !== null && value !== void 0) {
      merged[key] = value;
    }
  }
  return merged;
}
var PERMISSION_CATEGORIES = [
  {
    name: "Association",
    icon: "i-lucide-building-2",
    permissions: [
      { key: "canEditOrganization", label: "Modifier l'association" },
      // Seule permission de l'ancienne carte « Page publique », quasi vide
      // (Karim 2026-09-23).
      { key: "canEditPublicPage", label: "Modifier la page publique" },
      { key: "canManageReferral", label: "G\xE9rer le parrainage" },
      { key: "canManageStripe", label: "G\xE9rer les paiements (Stripe & PayPal)", danger: true },
      // L'équipe fait partie de l'organisation : plus de carte à part
      // (Karim 2026-09-23).
      { key: "canViewMembers", label: "Voir les membres" },
      { key: "canInviteMembers", label: "Inviter des membres" },
      { key: "canRemoveMembers", label: "Retirer des membres", danger: true },
      { key: "canUpdateRoles", label: "Modifier les r\xF4les", danger: true }
    ]
  },
  {
    name: "Paiements",
    icon: "i-lucide-smartphone-nfc",
    permissions: [
      { key: "canUseTapToPay", label: "Utiliser le Tap To Pay" },
      { key: "canViewPayouts", label: "Voir les versements" },
      {
        key: "canViewDailyTotal",
        label: "Voir le total encaiss\xE9 du jour"
      },
      { key: "canEditPaymentLink", label: "Modifier le lien de paiement" },
      { key: "canExportData", label: "Exporter les donn\xE9es" },
      { key: "canViewReports", label: "Voir les rapports" }
    ]
  },
  {
    name: "Dons",
    icon: "i-lucide-heart",
    permissions: [
      { key: "canViewDonations", label: "Voir les dons" },
      {
        key: "canViewDonationAmounts",
        label: "Voir les montants globaux (total collect\xE9, statistiques)"
      },
      { key: "canViewDonationCounts", label: "Voir le nombre de dons" },
      { key: "canExportDonations", label: "Exporter les dons" },
      { key: "canRefundDonations", label: "Rembourser", danger: true },
      { key: "canCancelSubscriptions", label: "Annuler un don r\xE9current", danger: true },
      { key: "canViewDonors", label: "Voir les donateurs" },
      { key: "canExportDonors", label: "Exporter les donateurs" }
      // 🔴 RETIRÉS DE L'ÉDITEUR le 2026-09-14 : « Supprimer les donateurs » et
      // « Supprimer l'organisation » ne commandaient RIEN — aucune route de
      // l'API, aucun écran, nulle part, ne supprime un donateur ou une
      // association. Deux interrupteurs qui donnaient l'illusion d'un réglage.
      // Les CLÉS restent dans la matrice (valeurs de rôle, overrides déjà
      // stockés, tests) : le jour où ces suppressions existeront, il suffira de
      // remettre la ligne ici ET de poser la garde côté serveur.
    ]
  },
  {
    name: "QR Codes",
    icon: "i-lucide-qr-code",
    permissions: [
      { key: "canViewQRCodes", label: "Voir les QR codes" },
      { key: "canCreateQRCodes", label: "Cr\xE9er des QR codes" },
      { key: "canEditQRCodes", label: "Modifier les QR codes" },
      { key: "canDeleteQRCodes", label: "Supprimer les QR codes", danger: true },
      { key: "canViewQRCodeAmounts", label: "Voir les montants" },
      { key: "canViewQRCodeDonors", label: "Voir les donateurs" }
    ]
  },
  {
    name: "Cagnottes",
    icon: "i-lucide-flag",
    permissions: [
      { key: "canViewCampaigns", label: "Voir les cagnottes" },
      { key: "canCreateCampaigns", label: "Cr\xE9er des cagnottes" },
      { key: "canEditCampaigns", label: "Modifier les cagnottes" },
      { key: "canDeleteCampaigns", label: "Supprimer les cagnottes", danger: true },
      { key: "canViewCampaignAmounts", label: "Voir les montants" },
      { key: "canViewCampaignDonors", label: "Voir les donateurs" }
    ]
  },
  {
    name: "Objectifs",
    icon: "i-lucide-target",
    permissions: [
      { key: "canViewObjectives", label: "Voir les objectifs" },
      { key: "canCreateObjectives", label: "Cr\xE9er des objectifs" },
      { key: "canEditObjectives", label: "Modifier les objectifs" },
      { key: "canDeleteObjectives", label: "Supprimer les objectifs", danger: true }
    ]
  },
  {
    name: "Billetterie",
    icon: "i-lucide-ticket",
    permissions: [
      { key: "canViewEvents", label: "Voir la billetterie" },
      { key: "canCreateEvents", label: "Cr\xE9er des \xE9v\xE9nements" },
      { key: "canEditEvents", label: "Modifier la billetterie" },
      { key: "canDeleteEvents", label: "Supprimer des \xE9v\xE9nements", danger: true },
      { key: "canCheckInTickets", label: "Valider les billets \xE0 l'entr\xE9e" },
      { key: "canViewEventAmounts", label: "Voir les montants" },
      { key: "canViewEventAttendees", label: "Voir les participants" }
    ]
  },
  {
    name: "Adh\xE9sions",
    icon: "i-lucide-id-card",
    permissions: [
      { key: "canViewMemberships", label: "Voir les adh\xE9sions" },
      { key: "canCreateMemberships", label: "Cr\xE9er des adh\xE9sions" },
      { key: "canEditMemberships", label: "Modifier les adh\xE9sions" },
      { key: "canDeleteMemberships", label: "Supprimer les adh\xE9sions", danger: true },
      { key: "canViewMembershipAmounts", label: "Voir les montants" },
      { key: "canViewMembershipMembers", label: "Voir les adh\xE9rents" }
    ]
  },
  {
    name: "Boutique",
    icon: "i-lucide-shopping-bag",
    permissions: [
      { key: "canViewShops", label: "Voir la boutique" },
      { key: "canCreateShops", label: "Cr\xE9er des boutiques" },
      { key: "canEditShops", label: "Modifier la boutique et les produits" },
      { key: "canDeleteShops", label: "Supprimer des boutiques", danger: true },
      {
        key: "canManageShopOrders",
        label: "Traiter les commandes (exp\xE9dier, exporter, rembourser)"
      },
      { key: "canViewShopAmounts", label: "Voir les montants" },
      { key: "canViewShopCustomers", label: "Voir les acheteurs" }
    ]
  }
];
var ROLE_OPTIONS = [
  {
    value: "admin",
    label: "Administrateur",
    description: "Gestion compl\xE8te de l'association",
    icon: "i-lucide-shield",
    color: "blue"
  },
  {
    value: "benevole",
    label: "B\xE9n\xE9vole",
    description: "Acc\xE8s aux dons et QR codes",
    icon: "i-lucide-heart-handshake",
    color: "green"
  },
  {
    value: "membre",
    label: "Membre",
    description: "Acc\xE8s en lecture seule",
    icon: "i-lucide-user",
    color: "gray"
  }
];
var PERMISSION_DEPENDENCIES = {
  canCreateQRCodes: "canViewQRCodes",
  canEditQRCodes: "canViewQRCodes",
  canDeleteQRCodes: "canViewQRCodes",
  canViewQRCodeAmounts: "canViewQRCodes",
  canViewQRCodeDonors: "canViewQRCodes",
  canCreateObjectives: "canViewObjectives",
  canEditObjectives: "canViewObjectives",
  canDeleteObjectives: "canViewObjectives",
  canCreateCampaigns: "canViewCampaigns",
  canEditCampaigns: "canViewCampaigns",
  canDeleteCampaigns: "canViewCampaigns",
  canViewCampaignAmounts: "canViewCampaigns",
  canViewCampaignDonors: "canViewCampaigns",
  canCreateEvents: "canViewEvents",
  canEditEvents: "canViewEvents",
  canDeleteEvents: "canViewEvents",
  canCheckInTickets: "canViewEvents",
  canViewEventAmounts: "canViewEvents",
  canViewEventAttendees: "canViewEvents",
  canCreateMemberships: "canViewMemberships",
  canEditMemberships: "canViewMemberships",
  canDeleteMemberships: "canViewMemberships",
  canViewMembershipAmounts: "canViewMemberships",
  canViewMembershipMembers: "canViewMemberships",
  canCreateShops: "canViewShops",
  canEditShops: "canViewShops",
  canDeleteShops: "canViewShops",
  canManageShopOrders: "canViewShops",
  canViewShopAmounts: "canViewShops",
  canViewShopCustomers: "canViewShops",
  canInviteMembers: "canViewMembers",
  canRemoveMembers: "canViewMembers",
  canUpdateRoles: "canViewMembers",
  canViewDonationAmounts: "canViewDonations",
  canViewDonationCounts: "canViewDonations",
  canExportDonations: "canViewDonations",
  canRefundDonations: "canViewDonations",
  canCancelSubscriptions: "canViewDonations",
  canExportDonors: "canViewDonors",
  canDeleteDonors: "canViewDonors",
  canManageStripe: "canEditOrganization",
  canDeleteOrganization: "canEditOrganization"
};
var VIEW_PERMISSIONS = Array.from(
  new Set(Object.values(PERMISSION_DEPENDENCIES))
);

export { PERMISSION_CATEGORIES, PERMISSION_DEPENDENCIES, PERMISSION_KEYS, ROLE_COLORS, ROLE_HIERARCHY, ROLE_LABELS, ROLE_OPTIONS, ROLE_PERMISSIONS, VALID_PERMISSION_KEYS, VIEW_PERMISSIONS, canActOnRole, isValidRole, mergePermissions };
//# sourceMappingURL=team.js.map
//# sourceMappingURL=team.js.map